import { useState, useEffect, useContext } from 'react';
import { MdArrowBack, MdManageAccounts } from 'react-icons/md';
import { AppContext } from '../App';
import logo_wide from '../assets/logo_wide.png';

export default function TopBarMain (props) {

  const appContext = useContext(AppContext);
  const [ title, setTitle ] = useState(props.title);

  useEffect(() => {
    setTitle(props.title);
  }, [ props.title ])
  return (
    <div className="TopBarMain">
      <div className="d-flex justify-content-between container" style={{ height: "100%" }}>
        <img onClick={() => appContext.navTo({ item: 'dashboard' }) } className="mNoMargin align-self-center" src={logo_wide} style={{ height: "50px", width: "auto", flexShrink: "0" }}/>
        <MdManageAccounts onClick={() => appContext.navTo({ item: 'account' })} color="var(--goldish)" size={40} className='align-self-center' style={{ display: "block", margin: "0 !important", padding: "0 !important", }}/>

      </div>
    </div>
  )
}
